var React = require('react');

function MailBlueIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.00012 6.75H30.0001C31.6501 6.75 33.0001 8.01562 33.0001 9.5625V26.4375C33.0001 27.9844 31.6501 29.25 30.0001 29.25H6.00012C4.35012 29.25 3.00012 27.9844 3.00012 26.4375V9.5625C3.00012 8.01562 4.35012 6.75 6.00012 6.75Z","stroke":"#0D71D7","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M33.0001 9.5625L18.0001 19.4062L3.00012 9.5625","stroke":"#0D71D7","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

MailBlueIcon.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = MailBlueIcon;

MailBlueIcon.default = MailBlueIcon;
